
import React, { useState, ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Alert, AlertDescription } from "@/components/ui/alert";

// Simple password protection component that uses a hardcoded password
// This is a temporary solution until we implement proper authentication
interface PasswordProtectionProps {
  children: ReactNode;
  configKey?: string; // We keep this for backward compatibility
}

const PasswordProtection: React.FC<PasswordProtectionProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  // Simple password check - using hardcoded password for now
  // In production, this should be replaced with proper authentication
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Simple hardcoded password for admin access
    if (password === "admin123") {
      setIsAuthenticated(true);
      setError(null);
    } else {
      setError("Invalid password");
    }
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="max-w-md mx-auto mt-8 p-6 bg-card rounded-lg shadow-md">
      <h2 className="text-2xl font-light mb-6">Admin Access</h2>
      
      {error && (
        <Alert variant="destructive" className="mb-4">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="password" className="block text-sm font-medium mb-1">
            Password
          </label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter admin password"
          />
        </div>
        
        <Button type="submit" className="w-full">
          Access Admin Area
        </Button>
      </form>
    </div>
  );
};

export default PasswordProtection;
